<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/blocks-builder'), active: true, meta: {type: 'string', value: `/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder`}},
     {title: $t('iframe.page_types.mo_noise_test_page'), disabled: true},
     {title: block.name, disabled: true}
   ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{$t('iframe.titles.update_block', {name: block.name})}} </h5>

      <BlockDetails
        v-model="blockForm"
        :form-errors="blockErrors"
        ref="blockDetails"
        :clientOptions="clientOptions"
      />
    </div>



    <!-- Buttons row -->
    <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
      <va-button class="btn-cancel" @click="handleCancel">
        {{$t('iframe.actions.cancel')}}
      </va-button>

      <va-button @click="handleSave">
        {{$t('iframe.actions.save')}}
      </va-button>
    </div>
    <!-- --- --- --- -->
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import {IframeService} from "@/api/IframeService";
import BlockDetails from "@/components/iframe/blocks-builder/noise/BlockDetails";
import IframeBlocksUpdateMixin from "@/mixins/IframeBlocksUpdateMixin";
import Errors from "@/utils/StandardErrors";

const errorsPrefix = 'iframe.blocks_builder.noise_block.errors.'
export default {
  mixins: [IframeBlocksUpdateMixin],
  components: {BlockDetails, LoadingPlaceholder, Breadcrumbs},
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      isSubmiting: false,
      blockForm:{
        name: null,
        lang: null,
        title: null,
        subtitle: null,
        increment_step: '',
        is_random: false,
        noise_end: '',
        prepare_attenuation: '',
        sound_noise_threshold: '',
        noise_start: '',
        items: [],
        cta_pass: null,
        pass_text: null,
        refer_text: null,
        client: null
      },
      block: null,
      blockErrors: new Errors()
    }
  },
  methods:{
    handleSave: function() {
      this.isSubmiting = true
      let formDataToSubmit = {...this.blockForm}
      const numberKeys =  ['increment_step', 'prepare_attenuation','noise_start', 'noise_end', 'sound_noise_threshold']

      numberKeys.forEach(key => {
        formDataToSubmit[key] = numberKeys[key] === '' ? null : +formDataToSubmit[key]
      })

      formDataToSubmit.items = []
      formDataToSubmit.items = this.$refs.blockDetails.getAddedItems().map(elem => parseInt(elem.id))
      formDataToSubmit.hearing_test_type = 'mo_noise'

      if(this.blockForm.lang) {
        formDataToSubmit.lang = this.blockForm.lang.lang
      }
      if(this.blockForm.client) {
        formDataToSubmit.client_id = this.blockForm.client.id
      }

      IframeService.updateNoisePage(this.block.id, formDataToSubmit)
      .then(res => {
        this.showToast(this.$t('iframe.blocks_builder.updated'), this.$store.state.successToastOptions)
        this.handleCancel()
      })
      .catch(errors => {
        if(errors.response.status === 422) {
          this.blockErrors.record(errors.response.data.errors, errorsPrefix)
        }
        this.showToast(this.$t('iframe.blocks_builder.update_error'), this.$store.state.errorToastOptions)
      })
      .finally(() => {
        this.isSubmiting = false
      })
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity => consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
